import React from 'react';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import './index.scss';

const SearchHeader = ({ searchData, inGuidedSearchNavExp, hasGuidedSearchTerms }) => {
    const { query, modifiedQueryString, searchInsteadUrl, nonTranslatedQuery } = searchData;
    const displayQuery = modifiedQueryString ? modifiedQueryString : query;
    return (
        <div className="search-header">
            <span className={classnames('title', { 'has-guided-search-terms': inGuidedSearchNavExp && hasGuidedSearchTerms })}>
                {inGuidedSearchNavExp && hasGuidedSearchTerms ?
                    <React.Fragment>
                        <I18n k="search_perseus.guided_search.refine_your_search" params={{ query: displayQuery }}/>
                    </React.Fragment>
                    :
                    <I18n k="search_perseus.subcategories_filter.query_in" params={{ query: displayQuery }}/>
                }
            </span>
            {modifiedQueryString &&
                <span className="search-instead"><I18n k="search_perseus.subcategories_filter.search_instead"/>&nbsp;
                    <a href={searchInsteadUrl}>{query}</a></span>}
            {nonTranslatedQuery &&
                <span className="search-instead"><I18n k="search_perseus.subcategories_filter.search_translated" params={{ nonTranslatedQuery, query }}/></span>
            }
        </div>
    );
};

export default SearchHeader;
